// Spinner: a ring that turns, in currentColor, 1em by default. Decorative unless given a label
// (then it is a status).
import { cn } from './cn';

export function Spinner({ label, className }: { label?: string; className?: string }) {
  return (
    <svg
      className={cn('inline-block size-[1em] flex-none animate-spin align-[-0.125em]', className)}
      viewBox="0 0 16 16"
      fill="none"
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="2" opacity="0.25" />
      <path d="M14 8a6 6 0 0 0-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
